import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

// Pages
import Sessions from './pages/Sessions';
import Session from './pages/Session';
import Login from './pages/Auth/Login';
import AccountPicker from './pages/Auth/AccountPicker';
import SignUp from './pages/Auth/SignUp';
import PasswordForgotten from './pages/Auth/PasswordForgotten';
import Account from './pages/Account/Account';
import Center from './pages/Account/Center';
import AttendanceSheet from './pages/Account/AttendanceSheet';
import Interns from './pages/Interns';
import Sign from './pages/Sign';

// Theme
import { ThemeProvider } from '@mui/material/styles';
import { useTheme } from './hooks/useTheme';

function App() {
    const theme = useTheme();

    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/signup" element={<SignUp />} />
                    <Route path="/password-forgotten" element={<PasswordForgotten />} />
                    <Route
                        path="/account-picker"
                        element={
                            <ProtectedRoute>
                                <AccountPicker />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/sessions"
                        element={
                            <ProtectedRoute>
                                <Sessions />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/sessions/:id"
                        element={
                            <ProtectedRoute>
                                <Session />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/sessions/:id/interns"
                        element={
                            <ProtectedRoute>
                                <Interns />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/account"
                        element={
                            <ProtectedRoute>
                                <Account />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/center"
                        element={
                            <ProtectedRoute>
                                <Center />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/attendance-sheet"
                        element={
                            <ProtectedRoute>
                                <AttendanceSheet />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/sign"
                        element={
                            <ProtectedRoute>
                                <Sign />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
